import InputField from "../../common/InputField";
import { IoMdClose } from "react-icons/io";
import { notify } from "../../common/Toast";
import { aging } from "../../utlis/apiService";
import Table from "../../common/Table";
import { AnimatePresence, motion } from "framer-motion";
import Button from "../../common/Button";
import { IoCheckmarkDone } from "react-icons/io5";
import { FaPaperPlane } from "react-icons/fa";
import { BsSave2 } from "react-icons/bs";

const AgingForm = ({
  data,
  onChange,
  onSubmit,
  onClose,
  setFormData,
  formData,
  refreshList,
  refreshAgingList,
  onMarkDone,
}) => {
  const rawStatus = formData?.status ?? data?.status ?? "";
  const isStatusDone =
    typeof rawStatus === "string" && rawStatus.toLowerCase() === "done";

  const parseTimeToMinutes = (t) => {
    if (!t) return null;
    const [h = 0, m = 0] = String(t).split(":").map(Number);
    return h * 60 + m;
  };

  const parseDurationToMinutes = (v) => {
    if (v === "" || v == null) return null;
    const s = String(v).trim();

    if (s.includes(":")) {
      const [h = 0, m = 0] = s.split(":").map(Number);
      return h * 60 + m;
    }
    const n = Number(s);
    if (Number.isFinite(n)) return Math.round(n * 60);

    return null;
  };

  const minutesToHHMM = (mins) => {
    const m = ((mins % 1440) + 1440) % 1440;
    const h = Math.floor(m / 60);
    const mm = m % 60;
    return String(h).padStart(2, "0") + ":" + String(mm).padStart(2, "0");
  };

  const handleTimeChange = (field, value) => {
    setFormData((prev) => {
      const updated = { ...prev, [field]: value };

      const startMins = parseTimeToMinutes(updated.in_Time);
      const durMins = parseDurationToMinutes(updated.out_Time);

      if (startMins != null && durMins != null) {
        updated.total_Time = minutesToHHMM(startMins + durMins);
      } else {
        updated.total_Time = "";
      }

      return updated;
    });
  };

  const updateDetailField = async (index, field, value) => {
    const updated = [...formData.agingDetails];
    updated[index][field] = value;

    setFormData((prev) => ({
      ...prev,
      agingDetails: updated,
    }));
  };

  const handleDeleteDetail = async (index, seq_No) => {
    const updated = [...formData.agingDetails];
    updated.splice(index, 1);
    setFormData((prev) => ({
      ...prev,
      agingDetails: updated,
    }));

    if (seq_No > 0) {
      await aging.agingDetailsDelete(seq_No);
      notify("Detail deleted", "success");
    }
  };

  // const handleMarkDone = async () => {
  //   try {
  //     const detail = formData.agingDetails[0] || {};
  //     const payload = {
  //       aging_No: detail.aging_No,
  //       batch_Id: detail.batch_Id,
  //       casting_No: detail.casting_No,
  //       die_Id: detail.die_Id,
  //       Created_By: 1,
  //     };

  //     await aging.MarkAgingDone(payload);

  //     notify("Production marked as done successfully", "success");
  //     onClose();
  //     refreshList();
  //     refreshAgingList();
  //   } catch (error) {
  //     notify("Failed to mark production as done", "error");
  //   }
  // };

  // const handleSaveAndMarkDone = async () => {
  //   try {
  //     const payload = {
  //       ...formData,
  //       start_Gas_Reading: parseFloat(formData.start_Gas_Reading || 0),
  //       end_Gas_Reading: parseFloat(formData.end_Gas_Reading || 0),
  //       total_Consumption: parseFloat(formData.total_Consumption || 0),
  //       temperature: parseFloat(formData.temperature || 0),
  //       agingDetails: formData.agingDetails.map((item) => ({
  //         ...item,
  //       })),
  //     };

  //     await aging.saveOrUpdate(payload);

  //     const detail = formData.agingDetails[0];
  //     if (!detail) {
  //       notify("No detail found for marking done", "error");
  //       return;
  //     }

  //     const markDonePayload = {
  //       aging_No: detail.aging_No,
  //       batch_Id: detail.batch_Id,
  //       casting_No: detail.casting_No,
  //       die_Id: detail.die_Id,
  //       Created_By: 1,
  //     };

  //     await aging.MarkAgingDone(markDonePayload);

  //     notify("Saved and marked as done", "success");
  //     onClose();
  //     refreshList();
  //     refreshAgingList();
  //   } catch (err) {
  //     notify("Error in Save or Mark Done", "error");
  //   }
  // };

  const disabledButtonStyle = isStatusDone
    ? "bg-gray-300 text-white cursor-not-allowed"
    : "bg-sky-700 hover:bg-sky-900 text-white";

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-slate-800 bg-opacity-75 flex items-center justify-center p-2 sm:p-4 z-9999">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 30,
            duration: 0.5,
          }}
          className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[95vh] overflow-y-auto"
        >
          <div className="bg-primary text-white flex justify-between items-center p-4 sm:p-6">
            <h2 className="text-xl font-semibold text-white uppercase">
              Profiles Under Production (Extrusion)
            </h2>
            <Button
              icon={IoMdClose}
              iconColor="text-white"
              iconSize="text-xl"
              onClick={onClose}
            />
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            className="p-4 sm:p-6 space-y-4"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <InputField
                label="aging no"
                name="aging_No"
                value={data.aging_No || ""}
                disabled
              />
              <InputField
                type="date"
                label="aging date"
                name="aging_Date"
                value={formData.aging_Date || ""}
                onChange={(val) =>
                  setFormData((prev) => ({ ...prev, aging_Date: val }))
                }
              />

              <InputField
                label="start gas reading"
                name="start_Gas_Reading"
                value={formData.start_Gas_Reading}
                onChange={(val) =>
                  setFormData((prev) => ({
                    ...prev,
                    start_Gas_Reading: val,
                  }))
                }
              />
              <InputField
                label="end gas reading"
                name="end_Gas_Reading"
                value={formData.end_Gas_Reading}
                onChange={(val) =>
                  setFormData((prev) => ({
                    ...prev,
                    end_Gas_Reading: val,
                  }))
                }
              />
              <InputField
                label="total consumption"
                name="total_Consumption"
                value={
                  (Number(formData.end_Gas_Reading) || 0) -
                  (Number(formData.start_Gas_Reading) || 0)
                }
                onChange={(val) =>
                  setFormData((prev) => ({
                    ...prev,
                    total_Consumption: val,
                  }))
                }
              />

              <InputField
                label="temperature"
                name="temperature"
                value={formData.temperature || ""}
                onChange={(val) =>
                  setFormData((prev) => ({
                    ...prev,
                    temperature: val,
                  }))
                }
              />

              <InputField
                label="shift"
                name="shift"
                value={formData.shift || ""}
                onChange={(val) =>
                  setFormData((prev) => ({
                    ...prev,
                    shift: val,
                  }))
                }
              />
              <InputField
                type="time"
                label="in time"
                name="in_Time"
                value={formData.in_Time || ""}
                onChange={(val) => handleTimeChange("in_Time", val)}
              />

              <InputField
                type="number"
                label="total hour"
                name="out_Time"
                value={formData.out_Time || ""}
                onChange={(val) => handleTimeChange("out_Time", val)}
              />

              <InputField
                label="Estimated Finish time"
                type="time"
                name="total_Time"
                value={formData.total_Time || ""}
              />
            </div>
            {/* <Table
              columns={columnData.map((col, idx) => ({
                ...col,
                render: (val, row) =>
                  col.render(val, row, formData.agingDetails.indexOf(row)),
              }))}
              data={formData.agingDetails}
              showActions={true}
              onDelete={(row, index) => handleDeleteDetail(index, row.seq_No)}
              onEdit={null}
            /> */}
            <div className="overflow-x-auto border border-slate-300 rounded-md">
              <table className="min-w-[900px] w-full text-[13px]">
                <colgroup>
                  <col className="w-36" />
                  <col className="w-36" />
                  <col className="w-28" />
                  <col className="w-28" />
                  <col className="w-28" />
                  <col className="w-24" />
                  <col className="w-24" />
                  <col className="w-56" />
                  <col className="w-20" />
                </colgroup>

                <thead className="bg-slate-50 text-slate-700 sticky top-0 z-10">
                  <tr className="text-center text-[12px] font-medium">
                    <th className="border border-slate-200 p-2">Batch ID</th>
                    <th className="border border-slate-200 p-2">Die No</th>
                    <th className="border border-slate-200 p-2">SO No</th>
                    <th className="border border-slate-200 p-2">Cut Length</th>
                    <th className="border border-slate-200 p-2">
                      Approved Pcs
                    </th>
                    <th className="border border-slate-200 p-2">Pcs</th>
                    <th className="border border-slate-200 p-2">Hardness</th>
                    <th className="border border-slate-200 p-2">Remark</th>
                    <th className="border border-slate-200 p-2">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {(formData?.agingDetails ?? []).map((row, idx) => (
                    <tr key={idx} className="hover:bg-slate-50">
                      <td className="border border-slate-200 p-1">
                        <input
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                          value={row.batch_Id ?? ""}
                          disabled
                        />
                      </td>

                      <td className="border border-slate-200 p-1">
                        <div className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 text-center">
                          {row.dieNumber && row.die_Id
                            ? `${row.dieNumber} (ID: ${row.die_Id})`
                            : row.dieNumber ||
                              (row.die_Id != null ? `ID: ${row.die_Id}` : "")}
                        </div>
                      </td>

                      <td className="border border-slate-200 p-1">
                        <input
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                          value={row.po_No ?? ""}
                          disabled
                        />
                      </td>

                      <td className="border border-slate-200 p-1">
                        <input
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                          value={row.cut_Length ?? ""}
                          disabled
                        />
                      </td>

                      <td className="border border-slate-200 p-1">
                        <input
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none text-right"
                          value={row.approved_Pcs ?? ""}
                          disabled
                        />
                      </td>

                      <td className="border border-slate-200 p-1">
                        <input
                          className="w-full rounded border border-slate-300 px-2 py-1 focus:ring-1 focus:ring-indigo-500 text-right"
                          value={row.quantity ?? ""}
                          onChange={(e) =>
                            updateDetailField(idx, "quantity", e.target.value)
                          }
                        />
                      </td>

                      <td className="border border-slate-200 p-1">
                        <input
                          className="w-full rounded border border-slate-300 px-2 py-1 focus:ring-1 focus:ring-indigo-500 text-right"
                          value={row.hardness ?? ""}
                          onChange={(e) =>
                            updateDetailField(idx, "hardness", e.target.value)
                          }
                        />
                      </td>

                      <td className="border border-slate-200 p-1">
                        <input
                          className="w-full rounded border border-slate-300 px-2 py-1 focus:ring-1 focus:ring-indigo-500"
                          value={row.remark ?? ""}
                          onChange={(e) =>
                            updateDetailField(idx, "remark", e.target.value)
                          }
                        />
                      </td>

                      <td className="border border-slate-200 p-1 text-center">
                        <button
                          type="button"
                          className="px-2 py-1 rounded text-white bg-red-600 hover:bg-red-700"
                          onClick={() => handleDeleteDetail(idx, row.seq_No)}
                          title="Delete row"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}

                  {(formData?.agingDetails ?? []).length === 0 && (
                    <tr>
                      <td
                        className="p-4 text-center text-slate-500"
                        colSpan={9}
                      >
                        No rows
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="flex justify-end gap-3 mt-4">
              {/* <Button
                text="Save or MarkDone"
                className={`${disabledButtonStyle} font-semibold text-md rounded-md p-2`}
                icon={IoCheckmarkDone}
                iconSize="w-6 h-6"
                iconColor="text-white"
                disabled={isStatusDone}
                onClick={handleSaveAndMarkDone}
              /> */}
              <Button
                text="Mark Done"
                className={`${disabledButtonStyle} font-semibold text-md rounded-md p-2`}
                iconSpacing="pr-2"
                icon={FaPaperPlane}
                iconSize="w-4 h-4"
                iconColor="text-white"
                disabled={isStatusDone}
                onClick={onMarkDone}
              />
              <Button
                text="Save"
                className={`${disabledButtonStyle} font-semibold text-md rounded-md p-2`}
                iconSpacing="pr-2"
                icon={BsSave2}
                iconSize="w-4 h-4"
                iconColor="text-white"
                disabled={isStatusDone}
                type="submit"
              />
              <Button
                text="Cancel"
                className="bg-gray-100 hover:bg-gray-200  text-gray-600  border border-gray-400 font-semibold text-md rounded-md p-2 "
                iconSpacing="pr-1"
                icon={IoMdClose}
                iconSize="w-6 h-6"
                iconColor="text-danger"
                onClick={onClose}
              />
            </div>
          </form>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default AgingForm;
